<template>
    <div class="body">
        <div class="container">
            <img class="back-style" :src="this.image">
            <div class="bodyDetails">
                <div>{{ title }}</div>
                <div class="details">
                    <div class="items">
                        <span> {{ this.naming}} </span>
                        <span v-if="this.isProduct && this.naming != '' && this.region != ''" :class="!isDesktop ? 'Sep-Mobile' : 'Sep'">-</span>
                        <span>{{ this.region }}</span>
                    </div>
                    <div class="items">
                        <span>{{ this.type }}</span>
                        <span v-if="this.isProduct && this.type != '' && this.millesime != ''" :class="!isDesktop ? 'Sep-Mobile' : 'Sep'">-</span>
                        <span>{{ this.millesime }}</span>
                    </div>
                    <div class="items">
                        <span>{{ this.domainName }}</span>
                    </div>
                </div>
                <div class="noteDetails">
                    <div class="note" v-if="rating > 0" @click="goNote">
                        <span v-for="n in 5" :key="n">
                            <img
                                v-if="rating >= n"
                                class="star"
                                alt="full star"
                                src="../../assets/full-star@3x.png"
                            />
                            <img
                                v-else
                                class="star"
                                alt="full star"
                                src="../../assets/empty-star@3x.png"
                            />
                        </span>
                    </div>
                    <div v-else class="noteText" @click="goNote">NOTER</div>
                    <div class="taste"  @click="$emit('click')">{{ $t('tasting.taste') }}</div>
                </div>
            </div>
        </div>
        <div class="price">
            {{`${this.price} €`}}
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

import unrated from '@/assets/rate_empty.png'
import rated from '@/assets/rate_full.png'
import degusted from '@/assets/wine_full.png'
import undegusted from '@/assets/wine_empty.png'
import VvStarNotation from '@/components/common/VvStarNotation'

export default {
    name: 'VvMobileTasteTilee',
    components: {VvStarNotation},
    props: {
        title: {
        type: String,
        required: true
        },
        ratingPath: {
        type: String,
        required: true
        },
        image: {
        type: String,
        required: false
        },
        status: {
        type: Object,
        required: false
        },
        bottleId: {
        type: String,
        required: false
        },
        rating: {
            type: Number,
            required: false
        },
        price: {
            type: Number,
            required: false
        },
        id: {
            type: String,
            required: false
        }
    },
    computed: {
        ...mapGetters([
        'getBottleById'
        ]),
        iconRate() {
            if (this.status && 'rating' in this.status) return rated
            else if (!this.status) return unrated
            else return unrated
        },
        iconWine() {
            if (this.status && this.status['complete']) return degusted
            else if (!this.status) return undegusted
            else return undegusted
        },
        product() {
            return this.getBottleById(this.bottleId)
        },
        isProduct(){
            return this.product ? true : false
        },
        naming () {
            return this.product ? this.product.naming : ''
        },
        millesime () {
            return this.product ? this.product.millesime : ''
        },
        region () {
            return this.product ? this.product.region : ''
        },
        domainName () {
            return this.product ? this.product.domainName : ''
        },
        isDesktop() {
            return ['mobile', 'tablet'].includes(this.$mq) ? false : true
        },
        type () {
            return this.product ? this.product.type : ''
        }
    },
    methods: {
        go() {
            if (this.$route.path.includes("/theme/")) {
                localStorage.setItem('comingFromTasteThemeId', this.$route.params.themeId)
            }
            this.$router.push({ name: 'tasting-rating', params: { tastingId: this.ratingPath } })
        },
        changeValue(value) {
            this.rating = value
            this.$emit(this.rating, value)

        },
        goNote() {
            if (this.$route.path.includes("/theme/")) {
                localStorage.setItem('comingFromTasteThemeId', this.$route.params.themeId)
            }
            this.$router.push({ name: 'tasting-rating', params: { tastingId: this.ratingPath } })
        },
        openBottle() {
            this.$router.push({
                name: 'shop-full-bottle',
                params: {
                productId: this.id
                }
            })
        },
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';
.price {
    display: flex;
    cursor: pointer;
    font-weight: 600;
    position: relative;
    top: 20px;
    color: rgb(255, 255, 255);
    font-size: 20px;
    padding: 5px 10px;
    height: auto;
    text-align: center;
    justify-content: center;
    border-radius: 23px;
    background: #D10A4A 0% 0% no-repeat padding-box;
}
.taste {
    display: flex;
    background-color: rgb(255, 255, 255);
    border-radius: 30px;
    margin-top: 5px;
    justify-content: center;
    padding: 5px;
    width: 90%;
    cursor: pointer;
    font-weight: 700;
}
.noteText {
    margin-top: 10px;
    background-color: rgb(255, 255, 255);
    border-radius: 30px;
    width: 50%;
    padding: 5px 12px;
    cursor: pointer;
    text-align: center;
    font-weight: 700;
}
.star {
    width: 20px;
    height: auto;
}
.note {
    margin-top: 10px;
    background-color: rgb(255, 255, 255);
    border-radius: 30px;
    width: 70%;
    display: flex;
    flex-direction: row;
    padding: 5px;
    justify-content: center;
    cursor: pointer;
}
.back-style {
    object-fit: cover;
    width: 130px;
    height: auto;
    border-radius: 20px;
}
.body {
    display: flex;
    align-items: center;
    flex-direction: column;
}
.container {
    padding: 10px 8px;
    display: flex;
    width: 100%;
    justify-content: flex-start;
}
.bodyDetails{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
}
.details {
    font-size: 12px;
}
.items {
    margin: 5px 0px;
}
// .price {
//     display: flex;
//     cursor: pointer;
//     font-weight: 600;
//     // position: relative;
//     // top: 20px;
//     margin-left: 60%;
//     color: rgb(255, 255, 255);
//     font-size: 20px;
//     padding: 5px 0px;
//     height: auto;
//     text-align: center;
//     justify-content: center;
//     border-radius: 23px;
//     background: #D10A4A 0% 0% no-repeat padding-box;
// }
// .container {
//     display: flex;
//     flex-direction: row;
//     transition: all 200ms linear;
//     // justify-content: center;
//     align-items: flex-start;
// }
</style>
